/** UI configuration passed to fibbl-model-viewer via data-ui-config */
export const FIBBL_MODEL_VIEWER_CONFIG = {
    "expand-button": true,
    "hint-text": { position: "bottom" },
    "light-control": false,
    zoom: false,
    "dimensions-control": false,
    "annotations-control": false,
};

export const isFibblEnabled = process.env.NEXT_PUBLIC_FIBBL_ENABLED === "true";
export const fibblDataToken = process.env.NEXT_PUBLIC_FIBBL_DATA_TOKEN || "";
export const fibblGoogleAnalyticsId = process.env.NEXT_PUBLIC_FIBBL_GOOGLE_ANALYTICS_ID || "";

export const FIBBL_INDEX = 0;
